import { createGlobalStyle } from "styled-components";

const GlobalFonts = createGlobalStyle`

@font-face {
    font-family: "BureauGrotCond";
    font-weight: normal;
    font-style: normal;
    src: 
        url(${
          process.env.PUBLIC_URL + "/fonts/BureauGrotCond.otf"
        }) format("opentype")
  }

  @font-face {
    font-family: "SouthCoast";
    font-weight: normal;
    font-style: normal;
    src: 
        url(${
          process.env.PUBLIC_URL + "/fonts/SouthCoast.ttf"
        }) format("truetype")
  }
  @font-face {
    font-family: "LocalCalibri";
    font-weight: normal;
    font-style: normal;
    src: 
      url(${
        process.env.PUBLIC_URL + "/fonts/calibri-regular.ttf"
      }) format("truetype")       
  }


  body {
    font-family:"BureauGrotCond", "Arial", sans-serif;
  } 
`;

export default GlobalFonts;
